import { CHAIN_USDC_ADDRESSES, CHAIN_WETH_ADDRESSES } from "../../tokens.js";
import { CORE_PINNED_BLOCK_HASHES, CORE_PINNED_BLOCK_HEIGHTS, CORE_PINNED_TRANSACTION_HASHES } from "../pinned.js";
import { TRANSFER_TOPIC, VITALIK } from "../../integration.js";
import { AAVE_V3_COLLECTOR, COMPOUND_V2_ETHEREUM_WHALE, DAI_ETHEREUM, ERC20_BALANCE_OF_REFERENCE_CALLDATA, MORPHO_ETHEREUM_WHALE, SWAP_QUOTE_AMOUNT, UNISWAP_V3_ROUTER_ETHEREUM, } from "../fixture-inputs.js";
export const ETHEREUM_TEST_CONFIG = {
    balance: {
        address: VITALIK,
        blockHeight: CORE_PINNED_BLOCK_HEIGHTS.ethereum,
    },
    tokenBalance: {
        address: VITALIK,
        token: CHAIN_USDC_ADDRESSES.ethereum,
        blockHeight: CORE_PINNED_BLOCK_HEIGHTS.ethereum,
    },
    blockQuery: {
        block: CORE_PINNED_BLOCK_HEIGHTS.ethereum,
        fixture: "getBlockByNumberEthereum",
    },
    balanceQuery: {
        address: VITALIK,
        blockHeight: CORE_PINNED_BLOCK_HEIGHTS.ethereum,
        fixture: "getBalanceEthereum",
    },
    tokenBalanceQuery: {
        address: VITALIK,
        token: CHAIN_USDC_ADDRESSES.ethereum,
        blockHeight: CORE_PINNED_BLOCK_HEIGHTS.ethereum,
        fixture: "getTokenBalanceEthereum",
    },
    blockHashQuery: {
        hash: CORE_PINNED_BLOCK_HASHES.ethereum,
        fixture: "getBlockByHashEthereum",
    },
    blockTransactionsQuery: {
        blockNumber: CORE_PINNED_BLOCK_HEIGHTS.ethereum,
        fixture: "getBlockTransactionsEthereum",
    },
    transfersQuery: {
        address: VITALIK,
        blockHeight: CORE_PINNED_BLOCK_HEIGHTS.ethereum,
        fixture: "getTransfersEthereum",
    },
    simulateCallQuery: {
        to: CHAIN_USDC_ADDRESSES.ethereum,
        data: ERC20_BALANCE_OF_REFERENCE_CALLDATA,
        blockHeight: CORE_PINNED_BLOCK_HEIGHTS.ethereum,
        fixture: "simulateCallEthereum",
    },
    traceTransactionQuery: {
        hash: CORE_PINNED_TRANSACTION_HASHES.ethereum,
        fixture: "traceTransactionEthereum",
    },
    tokenMetadataQuery: {
        address: CHAIN_USDC_ADDRESSES.ethereum,
        blockHeight: CORE_PINNED_BLOCK_HEIGHTS.ethereum,
        fixture: "getTokenMetadataEthereum",
    },
    tokenAllowanceQuery: {
        token: DAI_ETHEREUM,
        owner: VITALIK,
        spender: UNISWAP_V3_ROUTER_ETHEREUM,
        blockHeight: CORE_PINNED_BLOCK_HEIGHTS.ethereum,
        fixture: "getTokenAllowanceEthereum",
    },
    portfolioQuery: {
        address: VITALIK,
        blockHeight: CORE_PINNED_BLOCK_HEIGHTS.ethereum,
    },
    receiptQuery: {
        hash: CORE_PINNED_TRANSACTION_HASHES.ethereum,
        fixture: "getReceiptEthereum",
    },
    transactionByHashQuery: {
        hash: CORE_PINNED_TRANSACTION_HASHES.ethereum,
        fixture: "getTransactionByHashEthereum",
    },
    estimateGasQuery: {
        to: VITALIK,
        fixture: "estimateGasEthereum",
    },
    codeQuery: {
        address: CHAIN_USDC_ADDRESSES.ethereum,
        blockHeight: CORE_PINNED_BLOCK_HEIGHTS.ethereum,
        fixture: "getCodeEthereum",
    },
    logsQuery: {
        address: CHAIN_USDC_ADDRESSES.ethereum,
        topic0: TRANSFER_TOPIC,
        fromBlock: String(CORE_PINNED_BLOCK_HEIGHTS.ethereum),
        toBlock: String(CORE_PINNED_BLOCK_HEIGHTS.ethereum),
        fixture: "getLogsEthereum",
    },
    aaveV2Query: { address: VITALIK, blockHeight: CORE_PINNED_BLOCK_HEIGHTS.ethereum, fixture: "getAaveV2UserPositionsEthereum" },
    aaveV3Query: { address: AAVE_V3_COLLECTOR.ethereum, blockHeight: CORE_PINNED_BLOCK_HEIGHTS.ethereum, fixture: "getAaveV3UserPositionsEthereum" },
    compoundV2Query: { address: COMPOUND_V2_ETHEREUM_WHALE, blockHeight: CORE_PINNED_BLOCK_HEIGHTS.ethereum, fixture: "getCompoundV2UserPositionsEthereum" },
    compoundV3Query: { address: VITALIK, blockHeight: CORE_PINNED_BLOCK_HEIGHTS.ethereum, fixture: "getCompoundV3UserPositionsEthereum" },
    lidoQuery: { address: VITALIK, blockHeight: CORE_PINNED_BLOCK_HEIGHTS.ethereum, fixture: "getLidoUserPositionsEthereum" },
    morphoQuery: { address: MORPHO_ETHEREUM_WHALE, blockHeight: CORE_PINNED_BLOCK_HEIGHTS.ethereum, fixture: "getMorphoUserPositionsEthereum" },
    curveLlamaLendQuery: { address: VITALIK, blockHeight: CORE_PINNED_BLOCK_HEIGHTS.ethereum, fixture: "getCurveLlamaLendEthereum" },
    approvalsQuery: { address: VITALIK, blockHeight: CORE_PINNED_BLOCK_HEIGHTS.ethereum, fixture: "getApprovalsEthereum" },
    pendleV2InfoQuery: { fixture: "getPendleV2InfoEthereum" },
    curvePoolsQuery: { blockHeight: CORE_PINNED_BLOCK_HEIGHTS.ethereum, fixture: "getCurvePoolsEthereum" },
    curveLlamaLendMarketsQuery: { blockHeight: CORE_PINNED_BLOCK_HEIGHTS.ethereum, fixture: "getCurveLlamaLendMarketsEthereum" },
    uniswapV2QuoteQuery: { tokenIn: CHAIN_WETH_ADDRESSES.ethereum, tokenOut: CHAIN_USDC_ADDRESSES.ethereum, amount: SWAP_QUOTE_AMOUNT, blockHeight: CORE_PINNED_BLOCK_HEIGHTS.ethereum, fixture: "getUniswapV2QuoteEthereum" },
    uniswapV3QuoteQuery: { tokenIn: CHAIN_WETH_ADDRESSES.ethereum, tokenOut: CHAIN_USDC_ADDRESSES.ethereum, amount: SWAP_QUOTE_AMOUNT, blockHeight: CORE_PINNED_BLOCK_HEIGHTS.ethereum, fixture: "getUniswapV3QuoteEthereum" },
    uniswapV4QuoteQuery: { tokenIn: CHAIN_WETH_ADDRESSES.ethereum, tokenOut: CHAIN_USDC_ADDRESSES.ethereum, amount: SWAP_QUOTE_AMOUNT, blockHeight: CORE_PINNED_BLOCK_HEIGHTS.ethereum, fixture: "getUniswapV4QuoteEthereum" },
    approvalsRevokeQuery: { address: VITALIK, token: CHAIN_USDC_ADDRESSES.ethereum, spender: CHAIN_WETH_ADDRESSES.ethereum, fixture: "getApprovalsRevokeEthereum" },
};
